import React, { Component } from "react";
import CssClasses from "./InfoContainer.css";
import Auxx from "../../HOCs/AUXX/Auxx";

import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import * as ZebraErrorCodes from "../../HOCs/Constants/ZebraErrorCodes";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";
import * as DatabaseErrorCodes from "../../HOCs/Constants/DatabaseErrorCodes";

//import SiteIcons from "../../assets/fonts/site_icons/style.css";
import imgCloseDark from "../../assets/images/icons/icon_close_simple_dark.png";
import imgCloseLight from "../../assets/images/icons/icon_close_simple.png";

import imgAircash from "../../assets/images/img_aircash.png";
import RegularKeyboard, {
  KEYBOARD_POSITION_FOR_TICKET_CHECK
} from "../Keyboards/RegularKeyboard/RegularKeyboard";

import { CreateNewPartialPayoutRequest } from "../../Communication/PartialPayoutServicesHandler";

import beepMedium from "../../assets/sounds/beep_medium.mp3";

const BTN_UPLATI_NOVAC = 1;
const BTN_ISPLATI_NOVAC = 2;
const BTN_PROVJERA_LISTICA = 3;
const BTN_LOKATOR_KLADOMATA = 4;
const BTN_AIRCASH = 5;
const BTN_PROVJERA_POTVRDE_ZA_ISPLATU = 6;

const TXT_TICKET_NUMBER = 1;
const TXT_TICKET_CODE = 2;
const TXT_PAYOUT_RECEIPT_NUMBER = 3;
const TXT_PAYOUT_RECEIPT_CODE = 4;
//const BTN_SWAP_SCREENS = 6;

class InfoContainer extends Component {
  state = {
    isTicketPrinted: false,
    showsRegularKeyboard: false,
    currentTextboxID: -1,
    txtTicketNumberValue: "",
    txtTicketCodeValue: "",
    txtReceiptNumberValue: "",
    txtReceiptCodeValue: ""
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //updateaj i meceve info
    //vidi ako je u propsima da je isprintan tiket
    if (
      !this.state.isTicketPrinted &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_PRESENTER
      ) &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_RETRACT_READY
      ) &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_IN_RETRACT
      )
    ) {
      //postavi state da je isprintan!
      this.setState({
        isTicketPrinted: true
      });
    }

    if (
      this.state.isTicketPrinted &&
      !this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_PRESENTER
      )
    ) {
      //bio u presenteru a vise nije, zatvori tiket!
      //gasi load
      this.props.stopLoading(true);

      //zatvaraj
      this.closeExtraBets();
    }

    //ako je doslo do promjene current buttona, gasi
    if (prevProps.currentActionButton !== this.props.currentActionButton) {
      //gasi i cisti state
      this.setState({
        showsRegularKeyboard: false,
        txtTicketNumberValue: "",
        txtTicketCodeValue: "",
        txtReceiptNumberValue: "",
        txtReceiptCodeValue: "",
        currentTextboxID: -1
      });
    }
  }

  render() {
    if (this.props.shouldQuickCloseExtraBets) {
      return null;
    }

    let classes = [CssClasses.container];

    if (this.props.isBonusInfo) {
      //klase za info dole
      classes.push(CssClasses.bonusInfo);
      classes.push(
        this.props.isShowingBonusInfo
          ? CssClasses.showSaldoBonusInfoContainer
          : CssClasses.hideInfoContainer
      );
    } else {
      //klase za info gore
      classes.push(
        this.props.currentActionButton > 0
          ? CssClasses.showGenericInfoContainer
          : CssClasses.hideInfoContainer
      );
    }

    return (
      <div className={classes.join(" ")}>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        {this.state.showsRegularKeyboard &&
        this.props.currentActionButton > 0 ? (
          <RegularKeyboard
            closeHandler={() => {
              this.onCloseRegularKeyboard();
            }}
            keyDownHandler={(keyData, isShifted) => {
              this.regularKeyboard_KeyDown(keyData, isShifted);
            }}
            position={KEYBOARD_POSITION_FOR_TICKET_CHECK}
          />
        ) : null}

        <div
          className={[
            CssClasses.infoHeader,
            this.props.isBonusInfo ? CssClasses.bonusHeader : ""
          ].join(" ")}
        >
          {this.getHeaderMarkup(this.props)}
        </div>

        {this.props.isBonusInfo ? this.getBonusInfoMarkup() : null}

        {this.props.currentActionButton === BTN_AIRCASH
          ? this.getAircashMarkup()
          : null}

        {this.props.currentActionButton === BTN_ISPLATI_NOVAC
          ? this.getPayoutReceiptMarkup(this.props)
          : null}

        {this.props.currentActionButton === BTN_UPLATI_NOVAC
          ? this.getDepositMoneyMarkup()
          : null}

        {this.props.currentActionButton === BTN_LOKATOR_KLADOMATA
          ? this.getTerminalLocationsMarkup()
          : null}

        {this.props.currentActionButton === BTN_PROVJERA_LISTICA
          ? this.getCheckTicketMarkup()
          : null}

        {this.props.currentActionButton === BTN_PROVJERA_POTVRDE_ZA_ISPLATU
          ? this.getCheckPayoutReceiptMarkup()
          : null}
      </div>
    );
  }

  btnConfirmPartialPayout_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //provjeri ako ima para
    if (!(this.props.currentBalance > 0)) {
      this.props.showMessage("Vaš saldo je prazan, nemate što isplatiti!");
      return;
    }

    // this.props.updateBalance(2453, true);
    // return;

    //oduzmi 100 za test
    // this.props.addFundsToBalance(-100 * 100, true);
    // return;

    //pokreni load
    this.props.startLoading(false, true);

    //zovi servis
    CreateNewPartialPayoutRequest(
      this.props.machineInfo.MachineGUID,
      this.props.machineInfo.ActiveUserSessionID,
      this.submitPartialPayoutRequest_Callback.bind(this)
    );
  };

  submitPartialPayoutRequest_Callback = val => {
    console.log("CALLBACK IS ", val);

    if (!val) {
      this.props.showMessage("Nema odgovora od servera!");
      return;
    }

    if (val.ResponseCode === DatabaseErrorCodes.INVALID_MACHINE_GUID) {
      this.props.showMessage("Neispravan GUID!");
      return;
    }

    if (
      val.ResponseCode === DatabaseErrorCodes.SESSION_ID_TERMINAL_ID_MISMATCH
    ) {
      this.props.showMessage("Neispravna kombinacija ID-eva!");
      return;
    }

    if (val.ResponseCode === DatabaseErrorCodes.USER_SESSION_IS_EMPTY) {
      this.props.showMessage("Sesija nije aktivna!");
      return;
    }

    var tmpDate = new Date();

    //printaj
    window.cefCustomObject.printPayoutReceipt(
      JSON.stringify({
        receiptNumber: val.ReceiptNumber,
        securityCode: val.SecurityCode,
        localTimeOffset: tmpDate.getTimezoneOffset()
      })
    );

    //podesi na nulu
    this.props.updateBalance(0, true);
  };

  closeExtraBets = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //reset state
    this.setState({
      isTicketPrinted: false,
      showsRegularKeyboard: false
    });

    this.props.setIsShowingBonusInfo(false);
    this.props.setTerminalActionsActiveButton(0);

    //nakon timeouta upali
    setTimeout(() => {
      this.props.setCanShowExtraLiveBets(true);
      this.props.setCanShowExtraPrematchBets(true);
      console.log("PALIM...");
    }, 1000);
  };

  getHeaderMarkup = () => {
    //console.log(match);
    return (
      <Auxx>
        <span className={CssClasses.title}>
          {this.props.currentActionButton === BTN_UPLATI_NOVAC
            ? "Uplata novca"
            : this.props.currentActionButton === BTN_ISPLATI_NOVAC
            ? "Ispis potvrde za preostali saldo"
            : this.props.currentActionButton === BTN_PROVJERA_LISTICA
            ? "Provjera listića"
            : this.props.currentActionButton === BTN_PROVJERA_POTVRDE_ZA_ISPLATU
            ? "Provjera potvrde za isplatu"
            : this.props.currentActionButton === BTN_LOKATOR_KLADOMATA
            ? "Lokator kladomata"
            : this.props.currentActionButton === BTN_AIRCASH
            ? "Aircash"
            : this.props.isBonusInfo
            ? "Bonus info"
            : ""}
        </span>
        <img
          src={this.props.isBonusInfo ? imgCloseDark : imgCloseLight}
          className={CssClasses.btnClose}
          alt=""
          onClick={() => {
            this.closeExtraBets();
            return;
          }}
        />

        <div className={CssClasses.spacer} />

        {/* drugi redak */}
      </Auxx>
    );
  };

  onCloseRegularKeyboard = () => {
    this.setState({ showsRegularKeyboard: false });
  };

  regularKeyboard_KeyDown = (keyData, isShifted) => {
    console.log("KEY DATA ", keyData);
    console.log("SHIFTED ", isShifted);

    let oldVal = "";

    if (keyData.value === "shift") {
      return;
    }

    switch (this.state.currentTextboxID) {
      case TXT_TICKET_NUMBER:
        oldVal = this.state.txtTicketNumberValue + "";
        break;
      case TXT_TICKET_CODE:
        oldVal = this.state.txtTicketCodeValue + "";
        break;
      case TXT_PAYOUT_RECEIPT_NUMBER:
        oldVal = this.state.txtReceiptNumberValue + "";
        break;
      case TXT_PAYOUT_RECEIPT_CODE:
        oldVal = this.state.txtReceiptCodeValue + "";
        break;
      default:
        break;
    }

    if (keyData.value === "bksp") {
      //rezi ako je duzi od 0
      if (oldVal.length > 0) {
        oldVal = oldVal.slice(0, -1);
      }
    } else {
      oldVal = oldVal + (isShifted ? keyData.labelShifted : keyData.label);
    }

    if (oldVal.length > 20) {
      //nemre!
      return;
    }

    //i vrati u state
    switch (this.state.currentTextboxID) {
      case TXT_TICKET_NUMBER:
        this.setState({ txtTicketNumberValue: oldVal });
        break;
      case TXT_TICKET_CODE:
        this.setState({ txtTicketCodeValue: oldVal });
        break;
      case TXT_PAYOUT_RECEIPT_NUMBER:
        this.setState({ txtReceiptNumberValue: oldVal });
        break;
      case TXT_PAYOUT_RECEIPT_CODE:
        this.setState({ txtReceiptCodeValue: oldVal });
        break;
      default:
        break;
    }
  };

  getAircashMarkup = () => {
    return <img src={imgAircash} alt="" />;
  };

  getTerminalLocationsMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Koristite kladomat T123
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Najbliži ostali kladomati:
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
          <br />
          Caffe Bar Siroki, Ulica Ivana Ivanica 17
        </div>
      </div>
    );
  };

  getBonusInfoMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <div className={CssClasses.subtitle}>Što je bonus?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>Kako se dodjeljue bonus?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>Kako se koristi bonus?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>Kako se aktivira bonus?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>Kako se odigrava bonusom?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>Koja su pravila bonusa?</div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />

        <div className={CssClasses.subtitle}>
          Kako se izračunava dobitak kod uplate bonusom?
        </div>
        <div className={CssClasses.content}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </div>
        <hr className={CssClasses.sectionSeparator} />
        <div className={CssClasses.spacer} />
      </div>
    );
  };

  getDepositMoneyMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          U kladomat možete uplatiti novac u bilo kojem trenutku ako je upaljeno
          zeleno svjetlo na akceptoru za novčanice ili plavo svjetlo na
          akceptoru za kovanice.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Kladomat prima novčanice i kovanice u valuti Konvertibilna marka.
          <br />
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Kovanice koje kladomat prima su:
          <br />
          0.10 KM
          <br />
          0.20 KM
          <br />
          0.50 KM
          <br />
          1.00 KM
          <br />
          2.00 KM
          <br />
          5.00 KM
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Novčanice koje kladomat prima su:
          <br />
          10 KM
          <br />
          20 KM
          <br />
          50 KM
          <br />
          100 KM
          <br />
          200 KM
        </div>
        <br />
      </div>
    );
  };

  getCheckTicketMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <div className={[CssClasses.subtitle, CssClasses.whiteText].join(" ")}>
          Listić možete provjeriti skeniranjem QR koda na QR čitaču koji se
          nalazi na lijevoj strani terminala.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          U slučaju da je QR kod na vašem listiću oštećen, možete ga provjeriti
          ručno unošenjem broja listića i zaštitnog koda.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Informacije o unesenom listiću će se prikazati na donjem ekranu.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Broj listića:
        </div>
        <div>
          <input
            className={[
              CssClasses.txtUserInput,
              this.state.currentTextboxID === TXT_TICKET_NUMBER
                ? CssClasses.txtActive
                : ""
            ].join(" ")}
            type="text"
            onClick={() => this.txtBox_Enter(TXT_TICKET_NUMBER)}
            value={this.state.txtTicketNumberValue}
            onSelect={ev => {
              ev.target.selectionStart = ev.target.selectionEnd;
            }}
          />
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Zaštitni kod:
        </div>
        <div>
          <input
            className={[
              CssClasses.txtUserInput,
              this.state.currentTextboxID === TXT_TICKET_CODE
                ? CssClasses.txtActive
                : ""
            ].join(" ")}
            type="text"
            onClick={() => this.txtBox_Enter(TXT_TICKET_CODE)}
            value={this.state.txtTicketCodeValue}
            onSelect={ev => {
              ev.target.selectionStart = ev.target.selectionEnd;
            }}
          />
        </div>

        <br />
        <div className={[CssClasses.content].join(" ")}>
          <div
            className={CssClasses.baseBtn}
            onClick={() => {
              this.btnCheckTicket_Click();
            }}
          >
            PROVJERI
          </div>
        </div>
      </div>
    );
  };

  getCheckPayoutReceiptMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <div className={[CssClasses.subtitle, CssClasses.whiteText].join(" ")}>
          Potvrdu za isplatu možete provjeriti skeniranjem QR koda na QR čitaču
          koji se nalazi na lijevoj strani terminala.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          U slučaju da je QR kod na vašoj potvrdi oštećen, možete ju provjeriti
          ručno unošenjem broja potvrde i zaštitnog koda.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Informacije o unesenoj potvrdi će se prikazati na donjem ekranu.
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Broj potvrde:
        </div>
        <div>
          <input
            className={[
              CssClasses.txtUserInput,
              this.state.currentTextboxID === TXT_PAYOUT_RECEIPT_NUMBER
                ? CssClasses.txtActive
                : ""
            ].join(" ")}
            type="text"
            onClick={() => this.txtBox_Enter(TXT_PAYOUT_RECEIPT_NUMBER)}
            value={this.state.txtReceiptNumberValue}
            onSelect={ev => {
              ev.target.selectionStart = ev.target.selectionEnd;
            }}
          />
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Zaštitni kod:
        </div>
        <div>
          <input
            className={[
              CssClasses.txtUserInput,
              this.state.currentTextboxID === TXT_PAYOUT_RECEIPT_CODE
                ? CssClasses.txtActive
                : ""
            ].join(" ")}
            type="text"
            onClick={() => this.txtBox_Enter(TXT_PAYOUT_RECEIPT_CODE)}
            value={this.state.txtReceiptCodeValue}
            onSelect={ev => {
              ev.target.selectionStart = ev.target.selectionEnd;
            }}
          />
        </div>

        <br />
        <div className={[CssClasses.content].join(" ")}>
          <div
            className={CssClasses.baseBtn}
            onClick={() => {
              this.btnCheckPaymentReceipt_Click();
            }}
          >
            PROVJERI
          </div>
        </div>
      </div>
    );
  };

  txtBox_Enter = id => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //prikazi keyboard
    this.setState({ showsRegularKeyboard: true, currentTextboxID: id });
  };

  btnCheckTicket_Click() {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //gasi kb
    this.setState({ showsRegularKeyboard: false });

    //spremi ga u storage da pozoves event
    localStorage.setItem(
      LocalStorageKeys.LOCALSTORAGE_TICKET_CHECK,
      JSON.stringify({
        type: "ticket",
        ticketNumber: this.state.txtTicketNumberValue,
        ticketCode: this.state.txtTicketCodeValue,
        timestamp: new Date() //hack da se refresha
      })
    );
  }

  btnCheckPaymentReceipt_Click() {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //gasi kb
    this.setState({ showsRegularKeyboard: false });

    //spremi ga u storage da pozoves event
    localStorage.setItem(
      LocalStorageKeys.LOCALSTORAGE_TICKET_CHECK,
      JSON.stringify({
        type: "receipt",
        ticketNumber: this.state.txtReceiptNumberValue,
        ticketCode: this.state.txtReceiptCodeValue,
        timestamp: new Date() //hack da se refresha
      })
    );
  }

  getPayoutReceiptMarkup = () => {
    return (
      <div className={CssClasses.infoContent}>
        <div className={[CssClasses.subtitle, CssClasses.whiteText].join(" ")}>
          Vaš saldo:{" "}
          {(this.props.currentBalance * 0.01).toFixed(2) +
            "" +
            this.props.machineInfo.CurrencyCode}
        </div>
        <br />
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Nakon pritiska na dugme 'POTVRDI' bit će ispisana potvrda za isplatu u
          vrijednosti Vašeg salda.
        </div>
        <div className={[CssClasses.content, CssClasses.whiteText].join(" ")}>
          Potvrdu možete iskoristiti za igru ili ju isplatiti na bilo kojem WWin
          kladomatu ili u WWin poslovnici.
          <br />
        </div>
        <br />
        <div className={[CssClasses.content].join(" ")}>
          <div
            className={CssClasses.baseBtn}
            onClick={() => {
              this.btnConfirmPartialPayout_Click();
            }}
          >
            POTVRDI
          </div>
          <div
            className={[CssClasses.baseBtn, CssClasses.btnCancel].join(" ")}
            onClick={() => {
              this.closeExtraBets();
            }}
          >
            ODUSTANI
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    currentActionButton: state.rrNavigation.currentActionButton,
    isShowingBonusInfo: state.rrNavigation.isShowingBonusInfo,
    shouldQuickCloseExtraBets: state.rrNavigation.shouldQuickCloseExtraBets,
    printerStatusList: state.rrAppState.printerStatuses,
    currentBalance: state.rrBalance.currentBalance,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID)),
    updateBalance: (amountInCents, updateLocalStorage) =>
      dispatch(StoreActions.UpdateBalance(amountInCents, updateLocalStorage)),
    addFundsToBalance: (amountInCents, updateLocalStorage) =>
      dispatch(StoreActions.AddToBalance(amountInCents, updateLocalStorage))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoContainer);



// WEBPACK FOOTER //
// ./src/Components/InfoContainer/InfoContainer.js